<!--饼图-->
<template>
  <div class="echarts" style="height: 400px;width:450px" ref="pl"></div>
</template>
<script>
import * as echarts from "echarts";

export default {
  props: {
    data: Array
  },
  computed: {},
  mounted() {
    var myChart = echarts.init(this.$refs.pl);
    var option = {
      tooltip: {
        trigger: "item"
      },
      legend: {
        top: "90%",
        left: "center"
      },
      series: [
        {
          name: "",
          type: "pie",
          radius: ["30%", "50%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center"
          },
          // emphasis: {
          //   label: {
          //     show: true,
          //     fontSize: 40,
          //     fontWeight: "bold"
          //   }
          // },
          labelLine: {
            show: false
          },
          itemStyle: {
            normal: {
              color: function(colors) {
                var colorList = [
                  "#6BC1B8",
                  "#5B8DF1",
                  "#FD814F",
                  "#FB7A7D",
                  "#FEC74E",
                  "#3BA272"
                ];
                return colorList[colors.dataIndex];
              }
            }
          },
          data: this.data
        }
      ]
    };
    myChart.setOption(option);
    window.addEventListener("resize", () => {
      myChart.resize();
    });
  }
};
</script>
<style lang="css" scoped>
.echarts {
  width: 100%;
  height: 400px;
}
</style>